<span
  *ngIf="minimumQuantity > 1"
  class="vertically-center label-with-icon"
>
    <i class="label-with-icon__icon icon icon-users"></i>
      <span class="label">
        Minimum order {{ minimumQuantity }}
      </span>
</span>
